//! do not move in order of imports
import './bootstrap.scss';
//! it is important that it is always imported first

import { AuthProvider } from 'providers/AuthProvider';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import ToastProvider from 'providers/ToastProvider';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

if (container) {
    const root = ReactDOM.createRoot(container);
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                retry: false,
                refetchOnWindowFocus: false,
            },
        },
    });
    const publicUrl = process.env.PUBLIC_URL;

    root.render(
        <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <ToastProvider>
                        <BrowserRouter basename={publicUrl}>
                                <App />
                        </BrowserRouter>
                    </ToastProvider>
                </AuthProvider>
        </QueryClientProvider>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
} else {
    throw new Error('App root container not found!');
}
